<script>
    import AppHeader from './components/AppHeader.vue';
    import AppFooter from './components/AppFooter.vue';
    import AppDownloadModal from './components/shared/AppDownloadModal.vue';
    import {isLoggedIn, getServerSubdomain} from '@/services/Authentication';
    import UserService from '@/services/UserService';
    import FaxUserService from '@/services/FaxUserService';
    import SupportUserService from '@/services/SupportUserService';
    import {SET_ACTIVE_USER_ID} from '@/store/mutation-types';
    import { mapActions } from 'vuex';

    export default {
        name: 'app',
        components: {
            AppHeader,
            AppFooter,
            AppDownloadModal,
        },
        data() {
            return {
                isModalVisible: false,
                hasSeenWizzard: false,
            };
        },
        methods: {
            ...mapActions(['getTarif']),
        },
        created() {
            // Remove service worker if exist
            if (window.navigator && navigator.serviceWorker) {
                navigator.serviceWorker.getRegistrations()
                .then( (registrations) => {
                    for (const registration of registrations) {
                    registration.unregister();
                    }
                });
            }
            if (isLoggedIn() === true) {
                UserService.getAllUsers().then(responseGetAllUsers => {
                    this.userList = responseGetAllUsers.data;
                    FaxUserService._removeFaxUserFromList(this.userList);
                    SupportUserService._removeSupportUserFromList(this.userList);
                });
                if (this.$store.state.activeUserId === 0) {
                    UserService.getActiveUser().then(user => {
                        this.$store.commit(SET_ACTIVE_USER_ID, user.data.id);
                    });
                }
            }
        },
        watch: {
            $route(to, from) {
                if (from.path.indexOf('/wizard/') !== -1 && to.path === '/') {
                    this.isModalVisible = true;
                    this.hasSeenWizzard = true;
                }
            },
        },
    };
</script>

<template>
    <div>
        <div id="app">
            <AppHeader class="app-header"></AppHeader>
            <div class="app-content">
                <router-view></router-view>
            </div>
        </div>
        <AppFooter class="app-footer"></AppFooter>
        <AppDownloadModal
                @close="isModalVisible = false"
                :isModalVisible="isModalVisible"
                v-if="hasSeenWizzard"
        ></AppDownloadModal>
    </div>
</template>

<style lang="scss">
    @import "assets/scss/variables.scss";
    @import "assets/scss/general.scss";
    @import "../node_modules/typeface-open-sans/index.css";
    @import "../node_modules/modern-normalize/modern-normalize.css";

    * {
        box-sizing: border-box;
    }

    body.bm-overlay {
        background: $body-background;
    }

    #app {
        position: relative;
        padding: 72px 0;
        font-family: "Open Sans", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: $text;

        .app-content {
            margin: auto;
            max-width: 1024px;
            /*min-height: calc(100vh - 144px);*/
            /*overflow-y: auto;*/
            .container {
                padding: 32px 24px;
            }
        }
    }

    .container-fluid {
        width: 100%;
        height: 100%;
    }

/*     .bm-overlay {
        position: fixed;
        overflow: hidden;
    } */

    a {
        text-decoration: none;
        color: white;
    }
</style>
